export const paths = [
  { path: "/", label: "Dashboard" },
  { path: "/borrow", label: "Borrow" },
  { path: "/farm", label: "Farm" },
  // { path: "/vePREON", label: "vePREON" },  //#TODO! pending Uncomment to access vePREON page
  { path: "/faucet", label: "Faucet" },
  { path: "/calculator", label: "Calculator" },
  { path: "/vesting", label: "Vesting" }
];
